import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=0b052489&"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports